import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Grid, Typography, Box, DialogTitle, DialogContent, IconButton} from "@material-ui/core";
import {CloseIcon} from "@hapinest/theme";
import AccessibleIcon from "../../widget/streamline-icon/AccessibleIcon";
import NoIndexDialog from "../noIndex/NoIndexDialog";
import ApartmentShowMoreContent from "../../view/apartment/ApartmentShowMoreContent";

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1,
        background: theme.palette.grey[0],
        paddingTop: theme.spacing(2.625),
        paddingLeft: theme.spacing(2.25),
        paddingRight: theme.spacing(2.25),
        paddingBottom: 0
    },
    paddingContent: {
        paddingTop: theme.spacing(7.5),
        paddingLeft: theme.spacing(2.25),
        paddingRight: theme.spacing(2.25),
        paddingBottom: theme.spacing(2.25)
    },
    marginTop: {
        marginTop: -theme.spacing(1.875)
    },
    title: {
        display: "inline-flex",
        width: "100%",
        alignItems: "center",
        marginBottom: theme.spacing(2)
    },
    iconBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette.text.white}`,
        background: theme.palette.text.link,
        width: theme.spacing(2.25),
        height: theme.spacing(2.25),
        "& i": {
            display: "flex",
            color: theme.palette.text.white,
            fontSize: theme.spacing(1.25)
        }
    },
}));

const ApartmentShowMoreDialog = ({
    isOpen,
    onCloseDialog,
    apartment,
    apartmentShowMore,
    children
}) => {

    const classes = useStyles();

    const handleClose = () => {
        onCloseDialog();
    };

    return (
        <NoIndexDialog
            fullScreen
            maxWidth="xs"
            open={isOpen}
            onClose={handleClose}
            scroll="body"
        >
            <DialogTitle
                className={classes.dialogTitle}
            >
                <Grid
                    container
                    direction="row"
                    spacing={0}
                >
                    <Grid
                        item
                        md={11}
                        lg={11}
                        xs={11}
                        sm={11}
                        className={classes.title}
                    >
                        <Typography variant={"h6"}>
                            {apartment?.apartment_size_name + " " + apartment?.apartment_name}
                        </Typography>
                        {apartment?.wheelchair_accessibility &&
                            <Box
                                className={classes.iconBox}
                                ml={1.5}
                                mt={-0.3}
                            >
                                <AccessibleIcon />
                            </Box>
                        }
                    </Grid>
                    <Grid
                        item
                        md={1}
                        lg={1}
                        xs={1}
                        sm={1}
                    >
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            className={classes.marginTop}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent className={classes.paddingContent}>
                <ApartmentShowMoreContent
                    apartmentShowMore={apartmentShowMore}
                    apartmentExtraBed={apartment?.extra_bed}
                    apartmentWheelchair={apartment?.wheelchair_accessibility}
                />
                {children}
            </DialogContent>
        </NoIndexDialog>
    );
};

ApartmentShowMoreDialog.defaultProps = {
    isOpen: false
};

ApartmentShowMoreDialog.propTypes = {
    isOpen: PropTypes.bool,
    apartment: PropTypes.object.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    apartmentShowMore: PropTypes.object,
    children: PropTypes.any
};

export default ApartmentShowMoreDialog;
